module.exports = __webpack_public_path__ + "static/media/15.f260147e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/15.svg
// module id = 387
// module chunks = 14